import {Component, Input } from '@angular/core';

@Component({
	selector: 'loading',
	template: `
		<div
			class="text-center loader"
			*ngIf="isLoad"
			[sextant]="'loader'"
		>
			<img src="/img/loader.svg" class="img-responsive">
		</div>
	`
})
export class LoadingComponent {
	@Input() isLoad = false;
	
	constructor() {}
}
